import { makeAutoObservable } from "mobx";

export class StockistDTO {
  stockistId: number
  stockistName: string
  email: string
  activated: boolean
  billingAddressId?: number
  contactFirstName: string
  contactSurname: string
  contactTel: string
  vatNo: string
  customDiscount: number
  eori: string
  coverAlertsFrequency: StockistCoverAlertFrequency

  constructor(
    data: {
      stockistId: number,
      stockistName: string,
      email: string,
      activated: boolean,
      billingAddressId?: number,
      contactFirstName: string,
      contactSurname: string,
      contactTel: string,
      vatNo: string,
      customDiscount: number
      eori: string
      coverAlertsFrequency: StockistCoverAlertFrequency
    }) {
    this.stockistId = data.stockistId
    this.stockistName = data.stockistName
    this.email = data.email
    this.activated = data.activated
    this.billingAddressId = data.billingAddressId
    this.contactFirstName = data.contactFirstName
    this.contactSurname = data.contactSurname
    this.contactTel = data.contactTel
    this.vatNo = data.vatNo
    this.customDiscount = data.customDiscount
    this.eori = data.eori
    this.coverAlertsFrequency = data.coverAlertsFrequency;
    makeAutoObservable(this)
  }
}

export enum StockistCoverAlertFrequency {
  Never = 0,
  OnceAWeek = 1,
  TwiceAWeek = 2,
  FiveTimesAWeek = 5
}

export const alertFrequencyOptions = [
  { label: "Never", value: StockistCoverAlertFrequency.Never },
  { label: "Once a Week", value: StockistCoverAlertFrequency.OnceAWeek },
  { label: "Twice a Week", value: StockistCoverAlertFrequency.TwiceAWeek },
  { label: "5 Times a Week", value: StockistCoverAlertFrequency.FiveTimesAWeek },
];
